import { ThunkType } from "../../../../core/store/reducers";
import getSecurityValuationApi from "../api/getSecurityValuation";
import { setDisplayedValuation } from "../statisticsDataSlice";
import { SecurityValuationItem, SecurityValuationApiResponse } from "../types";

// Load funkcija (reset + fetch)
export const loadSecurityValuation = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedValuation(undefined));

	const valuation = await dispatch(
		getSecurityValuations(symbol)
	);
	console.log(valuation)

	dispatch(setDisplayedValuation(valuation));
};

export const getSecurityValuations = (
	symbol: string
): ThunkType<Promise<SecurityValuationItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();
		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}
		const { userId } = store.data.auth.current.user;

		const response: SecurityValuationApiResponse | undefined =
			await dispatch(
				getSecurityValuationApi(userId, symbol, "statistics")
			);

		console.log(response)
		if (!response || !response.meta) {
			return undefined;
		}
		const { meta, statistics } = response;
		const { valuations_metrics, financials } = statistics;
		const { income_statement, balance_sheet } = financials;

		return {
			symbol: meta.symbol,
			market_capitalization: valuations_metrics.market_capitalization,
			trailing_pe: valuations_metrics.trailing_pe,
			forward_pe: valuations_metrics.forward_pe,
			peg_ratio: valuations_metrics.peg_ratio,
			revenue_ttm: financials.income_statement.revenue_ttm,
			diluted_eps_ttm: financials.income_statement.diluted_eps_ttm,
			profit_margin: financials.profit_margin,
			return_on_equity_ttm: financials.return_on_equity_ttm,
			total_debt_to_equity_mrq: financials.balance_sheet.total_debt_to_equity_mrq,
		};
	};


